import SettingMailController from './setting.mail.controller';

export default {
    controller: SettingMailController,
    template: require('./setting.mail.tpl.html')
};
